// TODO: 准备封装提示信息
import { Message } from '@alifd/next';

export default Message;
// import { lzMsg } from 'lz-msg/LzMsg/lib';

// export default lzMsg;
